import type { EmptyReturnBoardItem, EmptyReturnBoardListQuery, Page } from '@chukua/common';
import { Table, type TableColumnsType } from 'antd';
import { PackageCheck, SearchX } from 'lucide-react';
import { EmptyState } from '../../../shared/components/EmptyState';
import { ListSearch } from '../../../shared/components/ListSearch';
import type { ListQueryControls } from '../../../shared/hooks/use-list-query';

interface DeadlinesTableProps {
  page: Page<EmptyReturnBoardItem>;
  columns: TableColumnsType<EmptyReturnBoardItem>;
  list: ListQueryControls<EmptyReturnBoardListQuery>;
  isRefreshing: boolean;
}

/** Search box plus the server-paged table; the old rows stay up, dimmed, while the next page loads. */
export function DeadlinesTable({ page, columns, list, isRefreshing }: DeadlinesTableProps) {
  return (
    <div className="flex flex-col gap-4">
      <ListSearch value={list.query.q} placeholder="Search container, job or customer" onSearch={(q) => list.setQuery({ q }, { replace: true })} />
      <Table
        rowKey="containerId"
        dataSource={page.items}
        columns={columns}
        loading={isRefreshing}
        scroll={{ x: 'max-content' }}
        locale={{ emptyText: list.isFiltered ? <NoMatchingContainers /> : <NothingOutstanding /> }}
        {...list.tableProps<EmptyReturnBoardItem>(page.total)}
      />
    </div>
  );
}

function NoMatchingContainers() {
  return <EmptyState icon={SearchX} title="No matching containers" description="No container with an empty to return matches this search or these filters." />;
}

function NothingOutstanding() {
  return <EmptyState icon={PackageCheck} title="No empties to return" description="Every container with a return deadline has been returned." />;
}
